import { alpha, Box, Card, CardContent, CircularProgress, Divider, Grid, InputAdornment, Paper, Typography, useTheme } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import WSTextField, { TextType } from "../../../Components/TextBox/WSTextBox";
import WSButton from "../../../Components/Button/WSButton";
import { callAPI, clearRequest, Method } from "../../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { useNavigate, useParams } from "react-router-dom";
import WSFileUpload from "../../../Components/FileUpload/WSFileUpload";
import { Header } from "../../../Components/Header/Header";
import WSHiddenField from "../../../Components/HiddenField/WSHiddenField";

export const TopBrand: React.FC<any> = React.memo((props) => {
  const { control, register, handleSubmit, setValue, reset } = useForm();
  const { showMessage } = useSnackbar();
  const params = useParams();
  const navigate = useNavigate();
  const id = params?.id;
  const theme = useTheme();

  const [subitting, setSubmitting] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true)
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const [defaultImg, setDefaultImg] = useState<string | null>(null);  
  const hasLoadedRef = useRef(false);

  useEffect(() => {
    return () => {
      reset();
      hasLoadedRef.current = false;
    };
  }, []);

  useEffect(() => {
    /**
     * Edit Function
     * @param id
     *
     */
    async function getTopBrandById(id: any) {
      try {
        setLoading(true)
        const response: any = await callAPI(`brands/getBy`, Method.GET, {}, id);

        if (response && response?.data) {
          reset();

          setValue("name", response.data.name);
          setValue("websiteUrl", response.data.websiteUrl);

          const imageUrl = response.data.imageUrl?.toString() || null;
          setDefaultImg(imageUrl);

          // Mark as loaded
          hasLoadedRef.current = true;
        }
      } catch (error) {
        console.error("failed to retrieve data", error);
      } finally {
        setLoading(false)
      }
    }
    
    if (id && !hasLoadedRef.current) {
      getTopBrandById(id)
    }
  }, [id, setValue]);

  /**
   * Method for Add/Update the data
   * @param data
   */
  const handleData = async (data: any) => {
    try {
      setSubmitting(true);
      const formData = new FormData()
      if (selectedFile) {
        formData.append("file", selectedFile!);
      }
      formData.append("name", data.name); // Add title
      formData.append("websiteUrl", data.websiteUrl);

      // const newRequest = clearRequest(request)
      if (id) {
        formData.append("id", id); // Add display
        const response: any = await callAPI(`brands/update/${id}`, Method.PUTFORMDATA, null, null, formData);
        if (response) {
          showMessage(response?.message, response.success === true ? "success" : "error");
          if (response?.success === true) {
            navigate('/brand/list')
          }
        }

      } else {
        const response: any = await callAPI("brands/create", Method.POSTFORMDATA, null, null, formData);
        if (response) {
          showMessage(response?.message, response.success === true ? "success" : "error");
          if (response?.success === true) {
            navigate('/brand/list')
          }
        }
      }
    } catch (e: any) {
      showMessage(e?.response?.data?.message || "something went wrong", 'error');
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancelClick = () => {
    navigate('/brand/list')
  }
  const handleUploadFile = (file: any) => {
    setDefaultImg(null)
    if (file && file.length > 0) {
      setSelectedFile(file[0]);
    }
  }
  const handleRemove = (id: string) => {
    alert(id)
  }

  {
    loading && (
      <div style={{
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255,255,255,0.7)',
        zIndex: 9999
      }}>
        <CircularProgress />
      </div>
    )
  }

  return (
    <>
      <Header
        type="simple"
        isDivider={true}
        title={`${id ? 'Edit' : 'Create'} Brand`}
        url="/brand/list"
        id={'topbrandImg'}
        isBackButton={true}
      />

      <form onSubmit={handleSubmit(handleData)}>
        <Card
          sx={{
            padding: 4,
            backgroundColor: "#fff",
            borderRadius: 3,
            marginTop: 3,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
            border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
            background: 'linear-gradient(to bottom, #ffffff, #f8fbff)'
          }}
        >
          <CardContent>
            <Typography
              variant="h6"
              sx={{
                mb: 3,

                fontWeight: 600,
                display: 'flex',
                alignItems: 'center',
                gap: 1
              }}
            >
              Brand Information
            </Typography>

            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <WSTextField
                  label={"Brand Name"}
                  {...register("name")}
                  id="name"
                  name="name"
                  control={control}
                  rules={{ required: true }}

                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      backgroundColor: alpha(theme.palette.primary.light, 0.05),
                      '&:hover fieldset': {
                        borderColor: theme.palette.primary.main,
                      },
                    }
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <WSTextField
                  label={"Website URL"}
                  {...register("websiteUrl")}
                  id="websiteUrl"
                  name="websiteUrl"
                  control={control}
                  rules={{ required: false }}

                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      backgroundColor: alpha(theme.palette.primary.light, 0.05),
                      '&:hover fieldset': {
                        borderColor: theme.palette.primary.main,
                      },
                    }
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <Divider sx={{ my: 2 }} />
                <Typography
                  variant="h6"
                  sx={{
                    mb: 2,
                    fontWeight: 600,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                  }}
                >
                  Brand Image
                </Typography>

                <Paper
                  variant="outlined"
                  sx={{
                    p: 2,
                    borderRadius: 2,
                    backgroundColor: alpha(theme.palette.primary.light, 0.03),
                    border: `1px dashed ${alpha(theme.palette.primary.main, 0.2)}`
                  }}
                >
                  <WSFileUpload
                    name="imageUrl"
                    label="Upload Brand Image"
                    control={control}
                    rules={{ required: defaultImg ? false : true }}
                    acceptFileTypes=".jpg,.jpeg,.png"
                    maxFileSizeMB={2}
                    defaultValue={defaultImg}
                    id={"imageUrl"}
                    image={true}
                    onChange={handleUploadFile}
                    onRemove={handleRemove}
                    align="Start"
                    isToolTipImg={false}
                    multiple={false}

                  />
                </Paper>
                <Typography variant="caption" sx={{ color: 'text.secondary', mt: 1, display: 'block' }}>
                  Recommended: Square image, 500x500px, JPG or PNG format, Max 2MB
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6} style={{ display: "none" }}>
                <WSHiddenField
                  name="id"
                  control={control}
                />
              </Grid>

              <Grid
                item
                xs={12}
                sx={{
                  marginTop: "3rem",
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 2,
                }}
              >
                <WSButton
                  id="submit"
                  label={"Save"}
                  type="submit"
                  size="small"
                  loading={subitting}
                />

                <WSButton
                  id="cancel"
                  label={"Cancel"}
                  type="button"
                  size="small"
                  className="ws-cancel"
                  onClick={handleCancelClick}
                  loading={subitting}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </form>
    </>
  );
});
